import React from "react"
import { motion } from "framer-motion"

export const HeroSection: React.FC = () => {
  return (
    <section className="relative pt-20 pb-8 flex flex-col items-center justify-center bg-white">
      <div className="container mx-auto px-6 md:px-12 flex flex-col items-center text-center max-w-5xl">
        <div className="space-y-6">
          <h1 className="text-5xl md:text-7xl font-bold bg-gradient-to-r from-purple-600 via-blue-600 to-pink-600 bg-clip-text text-transparent">
            빠르고 편리하게.
          </h1>
          <p className="text-xl md:text-2xl text-gray-600">
            원클릭으로 완성되는 진료 경험.
          </p>
          <div className="flex gap-4 pt-4 justify-center">
            <motion.button
              className="px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-full font-semibold text-lg shadow-lg hover:shadow-xl transition-all"
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => {
                if (window.top) {
                  window.top.location.href =
                    "https://www.sigmachart.co.kr/chart/"
                } else {
                  window.location.href = "https://www.sigmachart.co.kr/chart/"
                }
              }}
            >
              자세히 보기
            </motion.button>
            <motion.button
              className="px-8 py-4 bg-white text-purple-600 rounded-full font-semibold text-lg shadow-lg hover:shadow-xl transition-all border-2 border-purple-200"
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
              onClick={() =>
                window.open("https://www.sigmachart.co.kr/purchase/", "_blank")
              }
            >
              구매하기
            </motion.button>
          </div>
        </div>
      </div>
    </section>
  )
}
